import React, { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { AuthContext } from "../../AuthContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBookmark, faHeart } from "@fortawesome/free-regular-svg-icons";
import ImageComponent from "./ImageComponent";
import LZString from "lz-string";

const ArticleDetail = () => {
  const [oneArticle, setOneArticle] = useState({
    categoryName: "",
    correspondingItem: {
      categoryName: "",
    },
    description: "",
    id: 3,
  });

  const param = useParams();
  const artContext = useContext(AuthContext);

  useEffect(() => {
    if (artContext && artContext.articleDet) {
      const select = artContext.articleDet.filter(
        (article) => article.articles.length > 0
      );
      const matchingArticle = select.map((item) => item.articles).flat();
      const theSingleArt = matchingArticle.find(
        (obj) => obj.id === parseInt(param.id)
      );
      if (theSingleArt) {
        setOneArticle(theSingleArt);
      }
    }
  }, [artContext, param]);

  const handleSaveItem = (item) => {
    const savedItems = artContext.favoriteItem || [];
    const itemExists = savedItems.some((savedItem) => savedItem.id === item.id);
    if (!itemExists) {
      const updatedFavorites = [...savedItems, item];
      const compressedFavorites = LZString.compress(
        JSON.stringify(updatedFavorites)
      );
      artContext.setFavoriteItem(updatedFavorites);
      localStorage.setItem("fav", compressedFavorites);
    }
  };

  const handleSaveArticle = (item) => {
    const savedArt = artContext.articleSaving || [];
    const itemExists = savedArt.some((savedArt) => savedArt.id === item.id);
    if (!itemExists) {
      const updatedSaving = [...savedArt, item];
      const compressedSaving = LZString.compress(JSON.stringify(updatedSaving));
      artContext.setAarticleSaving(updatedSaving);
      localStorage.setItem("savve", compressedSaving);
    }
  };

  const handleHeart = artContext.favoriteItem?.some(
    (item) => item.id === oneArticle.id
  );
  const handleBookmark = artContext.articleSaving?.some(
    (item) => item.id === oneArticle.id
  );

  return (
    <div>
      <div className="container">
        <div className="row">
          <h1
            className="text-center mt-5 text-#e55"
            style={{ color: "#25e", fontSize: "28px", fontWeight: "bold" }}
          >
            {oneArticle.correspondingItem.categoryName || "Type name"}
          </h1>
        </div>
      </div>

      <div className="d-flex justify-content-center">
        <img
          className="mt-3 mb-2"
          src="img/businessman-3417761_1280.jpg"
          alt=""
        />
      </div>

      <div className="container w-75">
        <div className="row">
          <p style={{ textAlign: "center" }}>
            {oneArticle.correspondingItem.description || "Type description"}
          </p>

          <h2 style={{ textAlign: "center", fontWeight: "bold" }}>
            {oneArticle.categoryName || "Type Title"}
          </h2>
          <div style={{ margin: "20px auto", width: "80%", maxWidth: "80%" }}>
            {(
              <ImageComponent base64String={oneArticle.image} height={"100%"} />
            ) || "image of article"}
          </div>
          <p style={{ textAlign: "center" }}>
            {oneArticle.description || "Type description"}
          </p>
        <hr/>
        <h4 className="text-danger py-2" style={{
          textDecoration:"underline"
        }}>Sympatoms</h4>{" "}
          <p>{oneArticle.symptoms || " Type symptoms"}</p>
        <h4 className="text-danger"
         style={{
          textDecoration:"underline"
        }}
        >treatment</h4>{" "}
          <p>{oneArticle.treatment || " Type Treatment"}</p>
        </div>


        <hr className="mb-0" />
        <div className="d-flex flex-row align-items-center justify-content-end mt-0">
          <div
            onClick={() => handleSaveItem(oneArticle)}
            style={{ cursor: "pointer" }}
            className="px-2 py-2 d-flex flex-row align-items-center border-none rounded-2 cursor-pointer"
          >
            <FontAwesomeIcon
              className="fs-4"
              style={{ color: handleHeart ? "red" : undefined }}
              icon={faHeart}
            />
          </div>
          <div
            onClick={() => handleSaveArticle(oneArticle)}
            style={{ cursor: "pointer" }}
            className="px-2 py-2 d-flex flex-row align-items-center border-none cursor-pointer rounded-5 my-4"
          >
            <FontAwesomeIcon
              className="fs-4"
              style={{ color: handleBookmark ? "red" : undefined }}
              icon={faBookmark}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ArticleDetail;
